import styled, { createGlobalStyle } from "styled-components";

/** Savings / Analysis：Scenario + Re-calculate 工具条，避免全局按钮宽度与栅格挤压导致重叠 */
export const SavingsAnalysisToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 12px;

  & > .savings-analysis-toolbar__scenario {
    flex: 0 0 auto;
    min-width: 0;
    max-width: 100%;
  }

  & > .ant-btn.savings-analysis-recalculate-btn,
  .savings-analysis-recalculate-btn.ant-btn.ant-btn-primary {
    flex: 0 0 auto;
    width: auto !important;
    min-width: 10rem;
    max-width: none !important;
  }
`;

export const SavingsAnalysisFilterWrapper = styled.div`
  background: #fff;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  padding: 12px 16px;
  // margin: 0 24px 16px;

  .savings-analysis-filter-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
  }

  .savings-analysis-filter-body {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
  }

  .savings-analysis-utility-panel {
    min-width: 0;
    flex: 1;
  }

  .savings-analysis-utility-panel + .savings-analysis-utility-panel {
    margin-left: 16px;
    padding-left: 16px;
    border-left: 1px solid #f0f0f0;
  }

  .savings-analysis-field-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .savings-analysis-model-box {
    grid-column: 1 / -1;
    margin-top: 4px;
    padding: 6px 8px;
    background: #fafbfc;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
  }

  .savings-analysis-breakpoint-inputs {
    display: flex;
  }

  @media (max-width: 767px) {
    margin: 0 0 12px;
    padding: 12px;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    box-shadow: none;

    .savings-analysis-filter-toolbar {
      align-items: center;
      flex-direction: row;
      gap: 8px;
    }

    .savings-analysis-filter-toolbar .ant-btn {
      flex: 1;
      min-width: 0 !important;
      height: 40px;
    }

    .savings-analysis-filter-toolbar .anticon-copy {
      align-self: flex-end;
      width: 40px;
      height: 40px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background: #fff;
    }

    .savings-analysis-filter-body {
      display: block;
    }

    .savings-analysis-utility-panel {
      width: 100%;
      margin: 0 !important;
      padding: 0;
    }

    .savings-analysis-utility-panel + .savings-analysis-utility-panel {
      margin-top: 12px !important;
      padding-top: 12px;
      padding-left: 0;
      border-left: 0;
      border-top: 1px solid #f0f0f0;
    }

    .savings-analysis-field-grid {
      grid-template-columns: 1fr;
      gap: 10px;
    }

    .savings-analysis-model-box {
      margin-top: 0;
      padding: 10px;
    }

    .savings-analysis-breakpoint-inputs,
    .savings-analysis-breakpoint-inputs .ant-space-compact {
      width: 100%;
    }

    .savings-analysis-breakpoint-inputs .ant-input {
      width: 100% !important;
      min-width: 0;
    }

    .savings-analysis-filter-body .ant-segmented {
      width: 100%;
    }

    .savings-analysis-filter-body .ant-segmented-group {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    .select-add-new-control {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) 96px;
      gap: 8px;
    }
  }
`;

export const SavingsAnalysisFilterDrawerGlobalStyle = createGlobalStyle`
  .savings-analysis-filter-drawer .ant-drawer-content {
    border-radius: 14px 14px 0 0;
    overflow: hidden;
  }

  .savings-analysis-filter-drawer .ant-drawer-body {
    padding: 12px 12px 88px;
    overflow-y: auto;
    background: #fff;
  }

  .savings-analysis-filter-drawer .savings-analysis-filter-body {
    display: block;
  }

  .savings-analysis-filter-drawer .savings-analysis-utility-panel {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .savings-analysis-filter-drawer .savings-analysis-utility-panel + .savings-analysis-utility-panel {
    margin-top: 14px;
    padding-top: 14px;
    border-left: 0;
    border-top: 1px solid #f0f0f0;
  }

  .savings-analysis-filter-drawer .savings-analysis-field-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .savings-analysis-filter-drawer .savings-analysis-model-box {
    grid-column: auto;
    margin-top: 0;
    padding: 10px;
    background: #fafbfc;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
  }

  .savings-analysis-filter-drawer .select-add-new-control {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) 96px;
    gap: 8px;
  }

  .savings-analysis-filter-drawer .savings-analysis-breakpoint-inputs,
  .savings-analysis-filter-drawer .savings-analysis-breakpoint-inputs .ant-space-compact {
    width: 100%;
  }

  .savings-analysis-filter-drawer .savings-analysis-breakpoint-inputs .ant-input {
    width: 100% !important;
    min-width: 0;
  }

  .savings-analysis-filter-drawer .ant-segmented {
    display: block;
    width: 100%;
  }

  .savings-analysis-filter-drawer .ant-segmented-group {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .savings-analysis-filter-drawer .ant-segmented-item {
    min-width: 0;
  }

  .savings-analysis-drawer-actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    background: #fff;
    border-top: 1px solid #e6e9ee;
    box-shadow: 0 -4px 14px rgba(15, 23, 42, 0.08);
  }

  .savings-analysis-drawer-actions .ant-btn {
    height: 40px;
    border-radius: 8px;
  }
`;

export const SavingsPageWrapper = styled.div`
  padding: 0 16px;

  @media (max-width: 767px) {
    padding: 0;

    #Report_1 {
      margin-top: 0 !important;
    }

    .savings-chart-section {
      margin: 8px 0 !important;
    }

    .savings-summary-card {
      padding: 12px !important;
      border-left: 0 !important;
      border-right: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }
  }
`;
export const ChartWrapper = styled.div`
  display: block;
  position: relative;
  padding: 1rem 0rem;
  border: 1px solid #f0f0f0;
  border-radius: 6px;

  .title2 {
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }
`

export const AnalysisTableWrapper = styled.div`
    .ant-table-tbody > tr > .ant-table-cell:nth-child(-n+7) {
        background-color: #e6f7ff; /* Light green */
    }

    .ant-table-tbody > tr > .ant-table-cell:not(:nth-child(-n+7)):nth-child(-n+10) {
        background-color: #d6dce1; /* Light green */
    }

    .ant-table table{
        text-align: right;
    }
`
